import { Typography, Box } from "@mui/material" 
import FormDescription from '../../inputFormComponents/FormDescription'

const DescriptionMailServer = () => {
  return (
    <FormDescription
      paragraphs={[
        <Box key={1}>
          <Typography variant="body1">Rechnungen versenden:</Typography>
          <Typography variant="body2">Zum Versenden von Rechnungen kannst du hier eine bestehende Email-Adresse und deren Zugansdaten eingeben. Von dieser Adresse werden deine Rechnungen versendet.</Typography>
        </Box>,
        <Box key={1}>
          <Typography variant="body1">Konfiguration Postausgangs-Server:</Typography>
          <Typography variant="body2">Die Einstellungen für den Postausgangs-Server findest du bei deinem Email Anbieter. Suche dafür am besten nach den Postausgangs-Server-Einstellungen für deinen Anbieter.</Typography>
        </Box>,
        <Box key={1}>
          <Typography variant="body1">Einstellungen testen:</Typography>
          <Typography variant="body2">Nach dem Speichern kannst du deine Einstellungen mit einer Testmail prüfen.</Typography>
        </Box>,
      ]}
    />
  )
}

export default DescriptionMailServer